import { actionAddException } from 'react-redux-app/lib/modules/exception/actions';

import { getCurrentSiteId } from '../../site/selectors';

import {
  ACTION_LOAD_TEMPLATE_CONFIG_PREPARATION__FAIL,
  ACTION_LOAD_TEMPLATE_CONFIG_PREPARATION__REQUEST,
  ACTION_LOAD_TEMPLATE_CONFIG_PREPARATION__SUCCESS,
} from '../actionTypes';


const actionLoadTemplateConfigPreparationSuccess = templateConfigPreparation => ({
  type: ACTION_LOAD_TEMPLATE_CONFIG_PREPARATION__SUCCESS,
  payload: { templateConfigPreparation },
});

const actionLoadTemplateConfigPreparationFail = error => ({
  type: ACTION_LOAD_TEMPLATE_CONFIG_PREPARATION__FAIL,
  payload: { error },
});

export const actionLoadTemplateConfigPreparationRequest = () => (
  (dispatch, getState, { apiClientHelper }) => {
    dispatch({
      type: ACTION_LOAD_TEMPLATE_CONFIG_PREPARATION__REQUEST,
    });

    return apiClientHelper.get(
      `/rest/webmaster/site_config/preparation/${getCurrentSiteId(getState())}`
    ).then(
      templateConfigPreparation => {
        dispatch(actionLoadTemplateConfigPreparationSuccess(templateConfigPreparation));
      },
      error => {
        dispatch(actionLoadTemplateConfigPreparationFail(error));
      }
    ).catch(error => {
      dispatch(actionAddException(error));
    });
  }
);
